export default __webpack_public_path__ + "static/media/laundry2-afterB-1920w.7404d592.png";